import { Component, h, Prop, Element } from '@stencil/core';

declare const assetPath;

@Component({
    tag: 'app-video-embed',
    styleUrl: 'app-video-embed.scss',
    shadow: false,
})
export class AppVideoEmbed {

    @Element() root: HTMLElement;

    /**
     * Source for the placeholder image
     */
    @Prop() imgSrc: string;

    /**
     *  iframe height
     */
    @Prop() frameHeight: number;

    /**
     *  iframe width
     */
    @Prop() frameWidth: number;

    /**
     * Alt text for the placeholder image
     */
    @Prop() imgAlt: string;

    /**
     * Alt text for the video embed button
     */
    @Prop() btnAltText: string = "Click to see video";

    /**
     * Pass it should load modal
     */
    @Prop() noModal: boolean;

    /**
    * for hero with watch video button --> isButton = true
    */
    @Prop() isButton: boolean = false;

    dataSrc = ''

    componentDidLoad() {
        
        if (!this.noModal) {
            const playBtn: HTMLElement = this.root.querySelector('.video-embed-btn');
            const modal: HTMLElement = this.root.querySelector('.video-embed-content');
            const overlay: HTMLElement = modal.querySelector('.video-overlay');
            const iframeWrapper: HTMLElement = modal.querySelector('.iframe-wrapper');
            const closeBtns: NodeListOf<HTMLElement> = modal.querySelectorAll('.close-frame');
            const frame: any = modal.querySelector('iframe');
            const docBody: HTMLElement = document.querySelector('body');

            this.dataSrc = frame.dataset.videoUrl ?? frame.src
            frame.width = `${this.frameWidth}`
            frame.height = `${this.frameHeight}`

            // Opens lightbox
            playBtn.onclick = (e) => {
                // console.log(this.dataSrc)
                e.preventDefault();
                modal.classList.add('open');
                docBody.classList.add('lightbox-open');
                closeBtns[0].focus();
                if(iframeWrapper) {
                    iframeWrapper.style.display = 'block';
                }
                frame.setAttribute('src', this.dataSrc);
            };

            // Close lightbox on overlay click
            overlay.onclick = () => {
                modal.classList.remove('open');
                docBody.classList.remove('lightbox-open');
                frame.removeAttribute('src');
            };

            // Close lightbox if any close button is clicked
            closeBtns.forEach((close) => {
                close.onclick = (e) => {
                    e.preventDefault();
                    modal.classList.remove('open');
                    docBody.classList.remove('lightbox-open');
                    frame.removeAttribute('src');
                };
            });

            // Close lightbox if escape key is pressed
            document.addEventListener('keydown', (e) => {
                // console.log(e.key);
                // console.log(e.code);
                if (modal.classList.contains('open') && (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape')) {
                    e.preventDefault();
                    modal.classList.remove('open');
                    docBody.classList.remove('lightbox-open');
                    frame.removeAttribute('src');
                }
            });

            // Move focus to end of lightbox if it tries to pass first focusable
            closeBtns[0].addEventListener('keydown', (e) => {
                if ((e.key === 'Tab' || e.code === 'Tab') && e.shiftKey) {
                    e.preventDefault();
                    closeBtns[closeBtns.length - 1].focus();
                }
            });

            // Move focus to beginning of lightbox if it tries to pass last focusable
            closeBtns[closeBtns.length - 1].addEventListener('keydown', (e) => {
                if ((e.key === 'Tab' || e.code === 'Tab') && !e.shiftKey) {
                    e.preventDefault();
                    closeBtns[0].focus();
                }
            });
        }
    }

    render() {
        return (
            <div class={`video-embed ${this.isButton ? "is-cta-button" : ""}`}>
                {this.isButton ?
                    <button class="video-embed-btn btn btn-primary" aria-label="Watch video" type="button">Watch video</button> :
                    <button class="video-embed-btn" aria-label={this.btnAltText} type="button">
                        <div class="img lazy-load-bg" style={{ backgroundImage: `url('${this.imgSrc}')` }} role="presentation"></div>
                        <app-lazy-img css-class="yt-play" img-src={`${assetPath}/images/video-cta-play-btn.png`} img-alt="Play video"></app-lazy-img>
                    </button>
                }

                {!this.noModal && (
                    <div class="video-embed-content">
                        <div class="video-overlay"></div>

                        <div class="video-inner">
                            <div>
                                <div class="modal-spinner">
                                    <div class="spinner-border text-light" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                <div class="video-frame">
                                    <div>
                                        <button class="close-frame" aria-label="Close">
                                            <svg><use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#times"></use></svg>
                                        </button>
                                    </div>
                                    <slot />
                                    <div class="d-flex justify-content-center">
                                        <button class="close-frame close-frame-bottom visually-hidden-focusable" aria-label="Close">
                                            <svg><use href="/themes/custom/qsci/frontend/www/assets/icon/sheets/icons.svg#times"></use></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

}